var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "#003478"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2014 13.8263V23.0058C10.2014 23.1299 10.3185 23.2539 10.4824 23.2539H14.3466C14.4871 23.2539 14.6276 23.1505 14.6276 23.0058V13.6609H17.4145C17.555 13.6609 17.6721 13.5575 17.6955 13.4334L17.9297 10.6424C17.9532 10.4976 17.8126 10.3736 17.6487 10.3736H14.6042V8.38884C14.6042 7.91332 15.0258 7.54117 15.5644 7.54117H17.719C17.8595 7.54117 18 7.4378 18 7.29308V4.502C18 4.37795 17.8829 4.25391 17.719 4.25391H14.0656C11.9344 4.25391 10.2014 5.78383 10.2014 7.66522V10.3736H8.28103C8.14052 10.3736 8 10.477 8 10.6217V13.4334C8 13.5575 8.1171 13.6815 8.28103 13.6815H10.2014V13.8263V13.8263Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.15b7f3934d2e5e3b97c67f1f49c18f47.svg";
export { ForwardRef as ReactComponent };